// URL for pubchem
const pubchemURL = 'https://pubchem.ncbi.nlm.nih.gov/compound/';

export default pubchemURL;
